import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/authContext"; 

const AdminRoute = ({ children }) => {
  const { currentUser } = useAuth();

  // Redirect if the user is not logged in or not an admin
  if (!currentUser || currentUser.role !== "admin") {
    return <Navigate to="/login" replace />;
  }

  return children; // Render the admin route content if the user is an admin
};

export default AdminRoute;
